<template>
  <div
    v-if="unleash.isEnabled('SalonizedPay') && !adyenAppState.industryCode && !isUk"
  >
    <BaseVisualBanner
      :heading="
        replacePinapparaat(
          $t('register.salonized_pay.in_app.description', brandName()),
          company.country
        )
      "
      imagePath="/img/salonized-pay/checkout/awaiting-payment.svg"
      size="s"
      :primaryAction="{
        text: $t('global.learn_more'),
        routerLink: { name: 'salonized-pay' }
      }"
      v-test="'salonized-pay-banner'"
    />
  </div>
</template>
<script
  lang="ts"
  setup
>
import { brandName } from '@/helpers/brand-name';
import { replacePinapparaat } from '@/helpers/formatting';
import { useAdyenStore } from '@/stores/adyen';
import { useCompanyStore } from '@/stores/company';
import unleash from '@/unleash';

const { company, isUk } = useCompanyStore();
const { adyenAppState } = useAdyenStore();
</script>
